import React from 'react'

export default function MoonIcon (props) {
  return (
    <svg x='0px' y='0px' width='16px' height='16px' viewBox='0 0 16 16'>
      <g>
        <path fill='currentColor' d='M6,0C2.5,0.9,0,4.1,0,7.9C0,12.4,3.6,16,8.1,16c3.8,0,6.9-2.5,7.9-6C9.9,11.7,4.3,6.1,6,0z' />
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./components/Customers/icons/moon.js